import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("form", {
  id: "importForm",
  enctype: "multipart/form-data",
  method: "POST"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "importFile",
    name: "importFile",
    class: "form-control",
    type: "file"
  }),
  /*#__PURE__*/_createElementVNode("input", {
    id: "fileinput",
    style: {"display":"none"},
    type: "hidden",
    name: "MAX_FILE_SIZE",
    value: "30000000"
  })
], -1)

import axios from "axios";
import { useRoute } from "vue-router";
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { blocklyStore } from "../../blockly/blocklyStore";
import { utils } from "../../blockly/other/BlocklyUtils";
import { SessionUser } from "../../utils/SessionUser";
import { DialogHandler } from "./DialogHandler";


export default /*#__PURE__*/_defineComponent({
  __name: 'VrockFileUploadDialog',
  setup(__props) {

const route = useRoute();
const project_id = route.params.project_id as string;
const user_id = SessionUser.instance.userId;
const dialogId = DialogHandler.vrockFileUploadDialog;

/**
 * プロパティ
 */
const overrideUplaod = async () => {
  const importForm = document.getElementById("importForm") as HTMLFormElement;
  const importFile = document.getElementById("importFile") as HTMLInputElement;

  const title = importFile.files[0].name;
  const fd = new FormData(importForm);
  const isOk = confirm(
    "ファイルをインポートすると現在のプロジェクトは上書きされます。よろしいですか？"
  );
  if (isOk) {
    const url = `/webapi/file/import_api?project_id=${project_id}&user_id=${user_id}&title=${title}&token=${SessionUser.getJwtToken()}`;
    const response = await axios.post(url, fd, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    // console.log('response ', response);

    if (response.data.success) {
      const fileName = importFile.files[0].name;
      MessageDialog.alert(fileName + "をインポートしました");
      location.reload();
    } else {
      MessageDialog.alert("インポートで異常が発生しました。インポートを中止します。");
    }
    DialogHandler.hideDialog(dialogId);
  }
};

const addUpload = async () => {
  const importFile = document.getElementById("importFile") as HTMLInputElement;
  // console.log(importFile.files)
  if (importFile.files.length < 1) {
    MessageDialog.alert(`ファイルを選択してください。`);
    return;
  }
  const file = importFile.files[0];

  const text = await file.text();
  // console.log(text);
  try {
    const vrock = JSON.parse(text);
    const xml = vrock.block_xml;
    const parser = new DOMParser();
    const dom = parser.parseFromString(xml, "application/xml");
    const nodeList = dom.querySelectorAll("xml > block");

    const isOk = confirm("現在のプロジェクトにブロックを追加します。よろしいですか？");
    if (isOk) {
      for (const element of nodeList) {
        // console.log(element);
        utils.domToBlock(element, blocklyStore.workspace);
      }

      DialogHandler.hideDialog(dialogId);
    }
  } catch (e) {
    await MessageDialog.alert("ファイルの内容が正しく読み取れませんでした。");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    title: "vrockファイルアップロード"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-outline-danger",
        onClick: overrideUplaod
      }, " ブロックとコードを上書き "),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: addUpload
      }, "ブロックのみ追加")
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})